import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
} from "reactstrap";
import DesignCard from "../DesignCard";
import get from "lodash/get";
import history from "../../history";
import Loader from "../Loader";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MaterialTable from "material-table";

import { fetchQueryParams } from "../../utils/comman";
import { helperFunctionForStatus } from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

const _ = { get };

export default class JoinUserListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: false,
      toggleRejectModal: false,
      userId: "",
      page: 0,
      phone: "",
      email: "",
      limit: 100,
      data: [],
      toggleAddUser: false,
      togglePaymentModal: false,
      paymentDetail: "CASH",
      rideId: "",
      status: "PENDING",
      rejectionReason: "",
      addUserToggle: false,
      otherPaymentReason: "",
    };
  }

  componentDidMount() {
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    let state = this.state;

    if (params.tab === "join-event") {
      state.rideId = params.id;
      let data = {
        status: "PENDING",
      };
      this.setState({ ...state, data });
    }

    if (params.tab === "join-ride") {
      state.rideId = params.id;
      this.setState({ ...state });
    }

    let data = {
      status: state.status,
      id: state.id,
      flag: "",
    };
    if (params.tab === "join-event") {
      this.props.handleUsersForJoinRide(data);
    }
  }

  handleChangeStatus = (e) => {
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    state.status = e.target.value;
    this.setState({ ...state });
    let data = {
      status: state.status,
      id: this.props.selectedId,
    };
    this.props.handleUsersForJoinRide(data);
  };

  handleNameChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleGoBack = () => {
    this.props.handleToggleModel();
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleRowData = (rowData) => {
    if (rowData.ridersClubMember !== true) {
      history.push(`/user/detail?userId=${rowData._id}`);
    } else {
      history.push(`/rides/member-detail?guid=${rowData.guid}`);
    }
  };

  handleChangePaymentStatus = (e) => {
    let state = this.state;
    state.paymentDetail = e.target.value;
    this.setState({ ...state });
  };

  handleToggleAddUser = () => {
    let state = this.state;
    state.toggleAddUser = !state.toggleAddUser;
    this.setState({ ...state });
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();
    let { elements } = this.props;
    let state = this.state;
    let data = {
      page: state.page,
      phone: state.phone.toLowerCase().trim(),
      email: state.email.toLowerCase().trim(),
      limit: state.limit,
    };

    if (data.email !== "") {
      if (data.phone !== "") {
        if (data.phone.length >= 8 && data.phone.length <= 15) {
          this.props.handleFetchAllUser(data);
          this.props.handleSearchFilter();
        } else {
          toast.error(
            _.get(
              elements,
              "joinWebUserListing.phoneValidationElement",
              "phone Length should be more than 7 and less than 16"
            )
          );
        }
      } else {
        toast.error(
          _.get(
            elements,
            "joinWebUserListing.phoneEmptyValidationElement",
            "Phone cannot be empty"
          )
        );
      }
    } else {
      toast.error(
        _.get(
          elements,
          "joinWebUserListing.emailValidationElement",
          "Email cannot be empty"
        )
      );
    }
  };

  handleApproveUserWithFee = (id) => {
    let state = this.state;
    state.togglePaymentModal = !state.togglePaymentModal;
    state.userId = id;
    this.setState({ ...state });
  };

  handleToggleRejectModal = (id) => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    state.userId = id;
    this.setState({ ...state });
  };

  handleToggleRejectModalWithoutId = () => {
    let state = this.state;
    state.togglePaymentModal = !state.togglePaymentModal;
    this.setState({ ...state });
  };

  handleApproveUserWithoutFee = (id) => {
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    let state = this.state;
    if (this.props.singleRide) {
      if (this.props.singleRide.registrationFee !== "N/A") {
        let data = {
          moderationStatus: "APPROVED",
          paymentDetail: state.paymentDetail,
          ridersId: state.userId,
          rejectionReason: "",
          rideId: params.id,
          description: state.otherPaymentReason,
        };
        state.togglePaymentModal = !state.togglePaymentModal;
        this.setState({ ...state });
        this.props.handleUsersModerationForJoinRide(data);
        this.handleRemoveEmailAndphone();
      } else {
        let data = {
          moderationStatus: "APPROVED",
          paymentDetail: state.paymentDetail,
          ridersId: id,
          rejectionReason: "",
          rideId: params.id,
          description: state.otherPaymentReason,
        };
        this.props.handleUsersModerationForJoinRide(data);
        this.handleRemoveEmailAndphone();
      }
    }
  };

  handleDisApproveUser = () => {
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    let data = {
      moderationStatus: "REJECTED",
      paymentDetail: state.paymentDetail,
      ridersId: state.userId,
      rejectionReason: state.rejectionReason,
      rideId: params.id,
      description: state.otherPaymentReason,
    };
    state.toggleRejectModal = !state.toggleRejectModal;
    this.setState({ ...state });
    this.props.handleUsersModerationForJoinRide(data);
    this.handleRemoveEmailAndphone();
  };

  handleRemoveEmailAndphone = () => {
    let state = this.state;
    state.status = "PENDING";
    this.setState({ ...state });
  };

  handleAddUser = () => {
    let { elements } = this.props;
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);

    let data = {
      id: params.id,
      email: state.email,
      mobile: state.phone,
      moderationStatus: "",
      flag: "addUser",
    };
    if (data.email !== "") {
      if (data.phone !== "") {
        state.addUserToggle = true;
        this.setState({ ...state });
        this.props.handleFetchAllUser(data);
      } else {
        toast.error(
          _.get(
            elements,
            "joinWebUserListing.phoneEmptyValidationElement",
            "Phone cannot be empty"
          )
        );
      }
    } else {
      toast.error(
        _.get(
          elements,
          "joinWebUserListing.emailValidationElement",
          "Email cannot be empty"
        )
      );
    }
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="userListing hideSearch">
        {this.props.usersToJoinRideStatus !== false ? <Loader /> : null}
        <Form onSubmit={this.handleSubmitFilter}>
          <Row>
            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col lg={4}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "joinWebUserListing.statusLabel",
                          "Status"
                        )}
                      </Label>
                      <Input
                        type="select"
                        name="City"
                        className="w-100 customeSelectBtn my-2"
                        onChange={this.handleChangeStatus}
                        value={this.state.status}
                      >
                        <option value={"PENDING"}>
                          {_.get(
                            elements,
                            "joinWebUserListing.pendingElement",
                            "Pending"
                          )}
                        </option>
                        <option value={"APPROVED"}>
                          {_.get(
                            elements,
                            "joinWebUserListing.approvedElement",
                            "Approved"
                          )}
                        </option>
                        <option value={"REJECTED"}>
                          {_.get(
                            elements,
                            "joinWebUserListing.rejectedElement",
                            "Rejected"
                          )}
                        </option>
                      </Input>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col sm="12">
            <>
              {this.props.usersToJoinRide.length <= 0 ? (
                <div className="custom-m-table">
                  <MaterialTable
                    title=""
                    columns={[
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.fNameElement",
                          "First Name"
                        ),
                        field: "userID.fName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.lNameElement",
                          "Last Name"
                        ),
                        field: "userID.lName",
                      },
                      {
                        title: _.get(
                          elements,
                          // console.log(elements),
                          "joinWebUserListing.emailElement",
                          "Email"
                        ),
                        field: "userID.contactDetails.email",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.mobileElement",
                          "Phone"
                        ),
                        field: "userID.contactDetails.mobile.primary.number",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.rideStatusElement",
                          "Ride Status"
                        ),
                        field: "status",
                        render: (rowData) =>
                          helperFunctionForStatus(rowData.status, elements),
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.moderationStatusElement",
                          "Moderation Status"
                        ),
                        field: "moderationStatus",
                        render: (rowData) =>
                          helperFunctionForStatus(
                            rowData.moderationStatus,
                            elements
                          ),
                      },
                    ]}
                    options={{
                      actionsColumnIndex: -1,
                      search: false,
                      paging: true,
                      sorting: false,
                      pageSize: 10,
                    }}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h6>
                            {_.get(
                              elements,
                              "rideListTableElement.noRecordsFoundElement",
                              "No records to display"
                            )}
                          </h6>
                        ),
                      },
                      pagination: {
                        labelRowsSelect: _.get(
                          elements,
                          "customMaterialTableElement.labelRowsSelect",
                          "rows"
                        ),
                        previousTooltip: _.get(
                          elements,
                          "customMaterialTableElement.previousTooltip",
                          "previous"
                        ),
                        nextTooltip: _.get(
                          elements,
                          "customMaterialTableElement.nextTooltip",
                          "next"
                        ),
                      },
                    }}
                  />
                </div>
              ) : (
                <div className="custom-m-table">
                  <MaterialTable
                    title=""
                    columns={[
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.fNameElement",
                          "First Name"
                        ),
                        field: "userID.fName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.lNameElement",
                          "Last Name"
                        ),
                        field: "userID.lName",
                      },
                      {
                        title: _.get(
                          elements,
                          // console.log(elements),
                          "joinWebUserListing.emailElement",
                          "Email"
                        ),
                        field: "userID.contactDetails.email",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.mobileElement",
                          "Phone"
                        ),
                        field: "userID.contactDetails.mobile.primary.number",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.rideStatusElement",
                          "Ride Status"
                        ),
                        field: "status",
                        render: (rowData) =>
                          helperFunctionForStatus(rowData.status, elements),
                      },
                      {
                        title: _.get(
                          elements,
                          "joinWebUserListing.moderationStatusElement",
                          "Moderation Status"
                        ),
                        field: "moderationStatus",
                        render: (rowData) =>
                          helperFunctionForStatus(
                            rowData.moderationStatus,
                            elements
                          ),
                      },
                    ]}
                    data={this.props.usersToJoinRide}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h6>
                            {_.get(
                              elements,
                              "rideListTableElement.noRecordsFoundElement",
                              "No records to display"
                            )}
                          </h6>
                        ),
                      },
                      pagination: {
                        labelRowsSelect: _.get(
                          elements,
                          "customMaterialTableElement.labelRowsSelect",
                          "rows"
                        ),
                        previousTooltip: _.get(
                          elements,
                          "customMaterialTableElement.previousTooltip",
                          "previous"
                        ),
                        nextTooltip: _.get(
                          elements,
                          "customMaterialTableElement.nextTooltip",
                          "next"
                        ),
                      },
                    }}
                    options={{
                      actionsColumnIndex: -1,
                      search: false,
                      paging: true,
                      sorting: false,
                      pageSize: 10,
                    }}
                    detailPanel={(rowData) => {
                      return (
                        <React.Fragment>
                          {rowData ? (
                            <div className="hideSearch my-3 px-3">
                              <Row>
                                <Col
                                  xl={3}
                                  lg={4}
                                  md={6}
                                  sm={6}
                                  className="mb-4"
                                >
                                  <DesignCard
                                    name={_.get(
                                      elements,
                                      "joinWebUserListing.fNameDetailElement",
                                      "First Name"
                                    )}
                                    titleName={rowData.userID.fName}
                                  />
                                </Col>
                                <Col
                                  xl={3}
                                  lg={4}
                                  md={6}
                                  sm={6}
                                  className="mb-4"
                                >
                                  <DesignCard
                                    name={_.get(
                                      elements,
                                      "joinWebUserListing.lNameDetailElement",
                                      "Last Name"
                                    )}
                                    titleName={rowData.userID.lName}
                                  />
                                </Col>
                                <Col
                                  xl={3}
                                  lg={4}
                                  md={6}
                                  sm={6}
                                  className="mb-4"
                                >
                                  <DesignCard
                                    name={_.get(
                                      elements,
                                      "joinWebUserListing.rideStatusDetailElement",
                                      "Ride Status"
                                    )}
                                    titleName={helperFunctionForStatus(
                                      rowData.status,
                                      elements
                                    )}
                                  />
                                </Col>
                                <Col
                                  xl={3}
                                  lg={4}
                                  md={6}
                                  sm={6}
                                  className="mb-4"
                                >
                                  <DesignCard
                                    name={_.get(
                                      elements,
                                      "joinWebUserListing.moderationStatusDetailElement",
                                      "Moderation Status"
                                    )}
                                    titleName={helperFunctionForStatus(
                                      rowData.moderationStatus,
                                      elements
                                    )}
                                  />
                                </Col>
                              </Row>
                              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                                {rowData.moderationStatus === "PENDING" ? (
                                  <React.Fragment>
                                    <CustomButton
                                      customType={"button"}
                                      name={_.get(
                                        elements,
                                        "joinWebUserListing.joinButtonElement",
                                        "Approve"
                                      )}
                                      customClass={
                                        "btn-outline-dark ml-2 bg-none btnthemeColor"
                                      }
                                      customClick={
                                        this.props.singleRide
                                          ? this.props.singleRide
                                              .registrationFee !== "N/A"
                                            ? () =>
                                                this.handleApproveUserWithFee(
                                                  rowData._id
                                                )
                                            : () =>
                                                this.handleApproveUserWithoutFee(
                                                  rowData._id
                                                )
                                          : null
                                      }
                                    />
                                    <CustomButton
                                      customType={"button"}
                                      name={_.get(
                                        elements,
                                        "joinWebUserListing.unJoinedButtonElement",
                                        "Reject"
                                      )}
                                      customClass={
                                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                                      }
                                      customClick={() =>
                                        this.handleToggleRejectModal(
                                          rowData._id
                                        )
                                      }
                                    />
                                  </React.Fragment>
                                ) : null}

                                {rowData.moderationStatus === "APPROVED" ? (
                                  <React.Fragment>
                                    <CustomButton
                                      customType={"button"}
                                      name={_.get(
                                        elements,
                                        "joinWebUserListing.unJoinedButtonElement",
                                        "Reject"
                                      )}
                                      customClass={
                                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                                      }
                                      customClick={() =>
                                        this.handleToggleRejectModal(
                                          rowData._id
                                        )
                                      }
                                    />
                                  </React.Fragment>
                                ) : null}

                                {rowData.moderationStatus === "REJECTED" ? (
                                  <React.Fragment>
                                    <CustomButton
                                      customType={"submit"}
                                      name={_.get(
                                        elements,
                                        "joinWebUserListing.joinButtonElement",
                                        "Approve"
                                      )}
                                      customClass={
                                        "btn-outline-dark ml-2 bg-none btnthemeColor"
                                      }
                                      customClick={
                                        this.props.singleRide
                                          ? this.props.singleRide
                                              .registrationFee !== "N/A"
                                            ? () =>
                                                this.handleApproveUserWithFee(
                                                  rowData._id
                                                )
                                            : () =>
                                                this.handleApproveUserWithoutFee(
                                                  rowData._id
                                                )
                                          : null
                                      }
                                    />
                                  </React.Fragment>
                                ) : null}
                              </div>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    }}
                  />
                </div>
              )}
              <div className="d-flex justify-content-center justify-content-lg-end position-relative m-4">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "joinWebUserListing.backButtonElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => this.handleGoBack()}
                />
              </div>
            </>
          </Col>
        </Row>
        <Modal className="modalcenter" isOpen={this.state.togglePaymentModal}>
          <ModalHeader toggle={this.handleToggleRejectModalWithoutId}>
            {_.get(
              elements,
              "joinWebUserListing.paymentMethodElement",
              "Payment Method"
            )}
          </ModalHeader>
          <ModalBody>
            <Label className="inputLabel">
              {_.get(
                elements,
                "joinWebUserListing.paymentLabel",
                "Select Method"
              )}
            </Label>
            <Input
              type="select"
              name="City"
              className="w-100 customeSelectBtn my-2"
              onChange={this.handleChangePaymentStatus}
            >
              <option value={"CASH"}>
                {_.get(
                  elements,
                  "joinWebUserListing.cashPaymentMethodElement",
                  "Cash"
                )}
              </option>
              <option value={"NET BANKING"}>
                {_.get(
                  elements,
                  "joinWebUserListing.netBankingPaymentMethodElement",
                  "Net Banking"
                )}
              </option>
              <option value={"CARD"}>
                {_.get(
                  elements,
                  "joinWebUserListing.cardPaymentMethodElement",
                  "Card"
                )}
              </option>
              <option value={"OTHERS"}>
                {_.get(
                  elements,
                  "joinWebUserListing.otherPaymentMethodElement",
                  "Others"
                )}
              </option>
            </Input>

            {this.state.paymentDetail === "OTHERS" ? (
              <React.Fragment>
                <Label className="inputLabel" for="--">
                  {_.get(
                    elements,
                    "joinWebUserListing.paymentMethodLabelElement",
                    "Enter Payment Method"
                  )}
                </Label>
                <FormGroup>
                  <Input
                    type="textarea"
                    placeholder={_.get(
                      elements,
                      "joinWebUserListing.paymentMethodPlaceHolderElement",
                      "Enter Payment Method"
                    )}
                    name="otherPaymentReason"
                    id="--"
                    value={this.state.otherPaymentReason}
                    className="my-2 inputText"
                    onChange={(e) => this.handleNameChange(e)}
                    required
                  />
                </FormGroup>
              </React.Fragment>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "joinWebUserListing.submitButtonElement",
                "Submit"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => this.handleApproveUserWithoutFee(e)}
            />
          </ModalFooter>
        </Modal>
        <Modal className="modalcenter" isOpen={this.state.toggleRejectModal}>
          <ModalHeader toggle={this.handleToggleRejectModal}>
            {_.get(
              elements,
              "joinWebUserListing.rejectionElement",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={this.state.rejectionReason}
              customOnChange={(e) => this.handleNameChange(e)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "joinWebUserListing.rejectionButtonElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => this.handleDisApproveUser(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
